import React, { useState } from 'react';
import { Tabs, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';

import SearchForm from './SearchForm';
import ResultsGrid from '../ext/ResultsGrid';
import StickySearchPanel from '../../common/StickySearchPanel';

const DescriptionResults = () => {
  const { results, loading, error } = useSelector((s) => s.search);
  const { lastSearchQuery, forms } = useSelector((s) => s.tz);
  const [, setLocalState] = useState({
    previewSrc: null,
    originalPreviewSrc: null,
    croppedBlob: null,
    cropConfig: null,
    fileName: null,
  });

  const descriptionText = (forms?.description?.description || lastSearchQuery || '').trim();
  const displayQuery = descriptionText.length > 80 ? `${descriptionText.slice(0, 80)}…` : descriptionText;
  const mktuValue = forms?.description?.mktu;
  const formattedMktu = Array.isArray(mktuValue) ? mktuValue.join(', ') : mktuValue;
  const quantityValue = forms?.description?.quantity ?? 20;

  const items = [
    {
      key: 'description_tz',
      label: 'ТЗ',
      children: (
        <ResultsGrid
          items={results.description_tz}
          loading={loading.description_tz}
          error={error.description_tz}
          loadingTip="Поиск ТЗ по описанию…"
          errorTitle="Ошибка ТЗ"
          emptyTitle="ТЗ не найдены"
          requestType="По описанию (ТЗ)"
          searchQuery={lastSearchQuery}
          cardDescriptionVariant="semantic"
        />
      )
    },
    {
      key: 'description_req',
      label: 'Заявки',
      children: (
        <ResultsGrid
          items={results.description_req}
          loading={loading.description_req}
          error={error.description_req}
          loadingTip="Поиск заявок по описанию…"
          errorTitle="Ошибка заявок"
          emptyTitle="Заявок не найдено"
          requestType="По описанию (заявки)"
          searchQuery={lastSearchQuery}
          cardDescriptionVariant="semantic"
        />
      )
    },
    {
      key: 'description_wipo',
      label: 'ВИПО',
      children: (
        <ResultsGrid
          items={results.description_wipo}
          loading={loading.description_wipo}
          error={error.description_wipo}
          loadingTip="Поиск ВИПО по описанию…"
          errorTitle="Ошибка ВИПО"
          emptyTitle="ВИПО не найдено"
          requestType="По описанию (ВИПО)"
          searchQuery={lastSearchQuery}
          cardDescriptionVariant="semantic"
        />
      )
    }
  ];

  const compactContent = (
    <>
      <div className="sticky-search-panel__compact-body">
        {displayQuery && (
          <span className="sticky-search-panel__query-text">
            <SearchOutlined style={{ marginRight: 6 }} />
            «{displayQuery}»
          </span>
        )}
        <div className="sticky-search-panel__query-meta">
          {(loading.description_tz || loading.description_req || loading.description_wipo) && <Tag color="processing">Поиск…</Tag>}
          {quantityValue && <Tag color="blue">Кол-во: {quantityValue}</Tag>}
          {formattedMktu && <Tag color="geekblue">МКТУ: {formattedMktu}</Tag>}
        </div>
      </div>
    </>
  );

  return (
    <div style={{ width: '100%', padding: 16 }}>
      <SearchForm setLocalState={setLocalState} />
      <Tabs defaultActiveKey="description_tz" destroyInactiveTabPane={false} items={items} />
      <StickySearchPanel
        compactContent={compactContent}
        threshold={100}
        offsetTop={12}
        overlayOnly
      />
    </div>
  );
};

export default DescriptionResults;
